import React from "react";

/**
 * WhatsApp-style timestamp + status (small, muted, bottom-right).
 */
export function BubbleTimestamp({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-0.5 text-[11px] leading-none text-[#667781] whitespace-nowrap ${className}`}
    >
      {children}
    </span>
  );
}

/** Right-aligned row below media-only blocks (no inline text to float against) */
export function BubbleTimestampEnd({
  time,
  statusIcon,
  className = "",
}) {
  if (!time) return null;
  return (
    <div
      className={`flex justify-end items-center gap-0.5 min-h-[15px] ${className}`}
    >
      <BubbleTimestamp>
        <span>{time}</span>
        {statusIcon}
      </BubbleTimestamp>
    </div>
  );
}

/**
 * Absolute bottom-right timestamp inside a relative + padding-bottom wrapper.
 * Use for multi-line template / interactive body text (avoids overlap).
 */
export function BubbleTimestampOverlay({ time, statusIcon, className = "" }) {
  if (!time) return null;
  return (
    <span
      className={`absolute bottom-0 right-0 inline-flex items-center gap-0.5 text-[11px] leading-[15px] h-[15px] text-[#667781] whitespace-nowrap select-none ${className}`}
    >
      <span>{time}</span>
      {statusIcon}
    </span>
  );
}

/** Wrapper that reserves space for an overlay timestamp below text content */
export function BubbleTimestampContent({ children, className = "" }) {
  return (
    <div className={`relative min-w-0 pb-[18px] ${className}`}>
      {children}
    </div>
  );
}

/**
 * Floated to the bottom-right of a short plain-text block (same line when space allows).
 */
export function InlineBubbleTimestamp({ time, statusIcon, className = "" }) {
  if (!time) return null;
  return (
    <span
      className={`inline-flex items-center gap-0.5 float-right ml-2 mt-1 align-bottom text-[11px] leading-[15px] h-[15px] text-[#667781] whitespace-nowrap select-none ${className}`}
    >
      <span>{time}</span>
      {statusIcon}
    </span>
  );
}
